import React, { useEffect, useState } from "react";
import {
    CogIcon,
    UserIcon,
    BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link } from "react-router-dom";
import logo from '../../img/BBPS_Horizontal.png'
import { DetailsApi } from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";


export default function StepThreeCinSkipped() {
    const customerData = useSelector((state) => state.customerData.customerData);
const dispatch=useDispatch();
    const [showLogo, setShowLogo] = useState(false)

    const [cin, setCIN] = useState('L17110MH1973PLC019786')

    const handleCIN = (e) => {
        setCIN(e.target.value)
    }
    const getDetails = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": customerData?.custId
        }
        // console.log(Payload)
        const data = await dispatch(DetailsApi(Payload, customerData?.token_chr, "customer"));
                if(data?.result?.programId === 34||data?.result?.programId === 35){
           setShowLogo(false)
        }else{
            setShowLogo(true)
        }
    }

useEffect(() => {
    getDetails();
}, [])
    return (
        <>
            <body className='mailsentbody'>
                <div className="logoBG">
                    <div className="rightElement">
                        <CustomerHeader />
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <div className='bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg'>

                                <div className="grid grid-cols-12 gap-4">
 <div className="col-span-12 md:col-span-2 lg:col-span-2">
</div>
 <div className="col-span-12 md:col-span-8 lg:col-span-8">
 <div className="py-2 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">LIST OF DIRECTORS
                                        </h1>
                                    </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
{showLogo&&(
                                        <div style={{display:'flex',justifyContent:'right',marginTop:'-5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
)}
                                    </div>
 </div>
                                    <div className="py-2 text-center">
                                        <h1 className="text-sm text-gray-600">Please enter your CIN
                                        </h1>
                                    </div>
                                    <div className=' border-none border-collapse rounded-md'>
                                        <div className="py-4 text-center">
                                            <label for="email" className="block text-lg font-medium leading-6 text-gray-900">You have opted to skip CIN Verification
                                                <span className="text-red-600">*</span></label>
                                        </div>
                                        <div className="text-center">
                                            <button className="vtpRm-action-button">
                                                <Link to='/Customer/Step3CinDirectorList'>Activate CIN Verification</Link>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </div>
            </body>
        </>
    );
}